import { axiosInstance, multiPartInstance } from 'constants/api';

const setApiAuthenticationHeader = (access_token: string | null = null) => {
  if (access_token) {
    axiosInstance.defaults.headers.common['AuthenticationToken'] = `${access_token}`;
    multiPartInstance.defaults.headers.common['AuthenticationToken'] = `${access_token}`;
  } else {
    delete axiosInstance.defaults.headers.common['AuthenticationToken'];
    delete multiPartInstance.defaults.headers.common['AuthenticationToken'];
  }
};

export { setApiAuthenticationHeader };

export default setApiAuthenticationHeader;
